/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartItemDto } from './CartItemDto';
import {
    CartItemDtoFromJSON,
    CartItemDtoFromJSONTyped,
    CartItemDtoToJSON,
} from './CartItemDto';

/**
 * 
 * @export
 * @interface DeliveryReceiptRequestDto
 */
export interface DeliveryReceiptRequestDto {
    /**
     * 
     * @type {string}
     * @memberof DeliveryReceiptRequestDto
     */
    caller: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryReceiptRequestDto
     */
    invoice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeliveryReceiptRequestDto
     */
    tableName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliveryReceiptRequestDto
     */
    orderNumbers: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DeliveryReceiptRequestDto
     */
    locationId: number;
    /**
     * 
     * @type {Array<CartItemDto>}
     * @memberof DeliveryReceiptRequestDto
     */
    cartItems: Array<CartItemDto>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DeliveryReceiptRequestDto
     */
    locationIds: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DeliveryReceiptRequestDto
     */
    customerName?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryReceiptRequestDto
     */
    customerReferencePerson?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryReceiptRequestDto
     */
    emailRecipients?: string;
}

/**
 * Check if a given object implements the DeliveryReceiptRequestDto interface.
 */
export function instanceOfDeliveryReceiptRequestDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "caller" in value;
    isInstance = isInstance && "orderNumbers" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "cartItems" in value;
    isInstance = isInstance && "locationIds" in value;

    return isInstance;
}

export function DeliveryReceiptRequestDtoFromJSON(json: any): DeliveryReceiptRequestDto {
    return DeliveryReceiptRequestDtoFromJSONTyped(json, false);
}

export function DeliveryReceiptRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryReceiptRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caller': json['caller'],
        'invoice': !exists(json, 'invoice') ? undefined : json['invoice'],
        'tableName': !exists(json, 'tableName') ? undefined : json['tableName'],
        'orderNumbers': json['orderNumbers'],
        'locationId': json['locationId'],
        'cartItems': ((json['cartItems'] as Array<any>).map(CartItemDtoFromJSON)),
        'locationIds': json['locationIds'],
        'customerName': !exists(json, 'customerName') ? undefined : json['customerName'],
        'customerReferencePerson': !exists(json, 'customerReferencePerson') ? undefined : json['customerReferencePerson'],
        'emailRecipients': !exists(json, 'emailRecipients') ? undefined : json['emailRecipients'],
    };
}

export function DeliveryReceiptRequestDtoToJSON(value?: DeliveryReceiptRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caller': value.caller,
        'invoice': value.invoice,
        'tableName': value.tableName,
        'orderNumbers': value.orderNumbers,
        'locationId': value.locationId,
        'cartItems': ((value.cartItems as Array<any>).map(CartItemDtoToJSON)),
        'locationIds': value.locationIds,
        'customerName': value.customerName,
        'customerReferencePerson': value.customerReferencePerson,
        'emailRecipients': value.emailRecipients,
    };
}

